import template from './mobile_configuration_add_image.html';
import tr from '../../lib/default-translator.js';

class MobileConfigurationAddImageViewModel
{
	constructor (dialog)
	{
		this.dialog = dialog;
		this.new_name = ko.observable('');
		this.filename = ko.observable('');
		this.after_upload = this.after_upload.bind(this);
	};

	before_upload(formData)
	{
		formData.append('filename', this.filename());
	};

	async after_upload()
	{
		Grape.alerts.alert({type: 'success', message: tr('Successfully uploaded file'), title: tr('Success', 'Success')});
		$('#upload_input').val('');
		$('#upload_btn').button('reset');
		this.dialog.updateData();
		this.dialog.close();
	};

	close()
	{
		this.dialog.close();
	}
};

class MobileConfigurationAddImagePage
{
	constructor (bindings)
	{
		this.viewModel = new MobileConfigurationAddImageViewModel(this);
		this.bindings = bindings;
	};

	init()
	{
		$('input[id=batch_file]').change(() => {
			$('#upload_input').val($(this).val().replace('C:\\fakepath\\', ''));
		});
	};

	updateData()
	{
		this.viewModel.filename(this.bindings.filename);
	};
};

export default {
	name: 'MobileConfigurationAddImage',
	dialog_class: MobileConfigurationAddImagePage,
	template: template,
	template_filename: 'translation/dialogs/mobile_configuration_add_image',
	provider: 'ps'
};
